<template>
    <div>
        <public-title showBack>房型动态</public-title>
        <div class="bg-white box-shadow load-area">
            <header class="pl-3">
                酒店信息
                <label v-if="path == 'hotel' && Detail.info && userLoginMessage.type == 3" class="Rstatus">
                    <span v-if="Detail.info.hotel_info.status == 1" class="text-blue">状态：已推送(采购商:<span class="text-danger">{{Detail.info.hotel_info.travel_fail_nums + Detail.info.hotel_info.travel_succ_nums}}</span>家)</span>
                    <span v-if="Detail.info.hotel_info.status == 0" class="text-danger">状态：未推送</span>
                    <span v-if="Detail.info.hotel_info.status == 2" class="text-danger">状态：已取消</span>
                </label>
                <label v-else class="Rstatus">
                    <span v-if="Detail.travel_push_time > 0 && Detail.hotel_push_time > 0" class="text-blue">状态：已全部推送</span>
                    <span v-if="Detail.travel_push_time == 0" class="text-danger">状态：采购商未推送</span>
                    <span v-if="Detail.hotel_push_time == 0" class="text-danger ml-3">状态：酒店未推送</span>
                </label>
            </header>
            <div class="pt-4 pl-3 pr-3 pb-4">
                <div v-if="path == 'hotel' && Detail.info && userLoginMessage.type == 3">
                    <div class="text-left">名称：<span class="text-blue">{{Detail.info.hotel_info.title}}</span></div>
                    <div class="text-left mt-2 mb-2">星级：{{Detail.info.hotel_info.star | formatVar('HotelStar')}}</div>
                    <div class="text-left">区域：{{Detail.info.hotel_info.province_name}}/{{Detail.info.hotel_info.city_name}}/{{Detail.info.hotel_info.district_name}}</div>
                    <el-row class="mt-4">
                        <el-col :span="2" class="text-left">房态表格：</el-col>
                        <el-col :span="22">
                            <el-input disabled v-if="Detail.info.room_start_info.id" :rows="4" type="textarea" v-model="Detail.info.room_start_info.remarks" />
                            <div v-else>
                                <ul class="list-head mt-3"><li class="w-50" v-for="item in typeArr" :key="item">{{item}}</li></ul>
                                <ul class="ullinetype">
                                    <li v-for="(item, index) in Detail.info.room_start_info" :key="index" class="linetype">
                                        <span>
                                            {{item.years}}
                                            <font v-if="Number(item.years.substring(0,2)) < month">
                                                <i class="text-danger" v-if="getMyDay(year1 + item.years) == '周五'">(周五)</i>
                                                <i class="text-danger" v-if="getMyDay(year1 + item.years) == '周六'">(周六)</i>
                                            </font>
                                            <font v-else>
                                                <i class="text-danger" v-if="getMyDay(year + item.years) == '周五'">(周五)</i>
                                                <i class="text-danger" v-if="getMyDay(year + item.years) == '周六'">(周六)</i>
                                            </font>
                                        </span>
                                        <span v-for="(v, index) in 3" :key="index">
                                            <label v-if="index == 0">
                                                <label v-if="item.data[0].room_type == 1">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                            </label>
                                            <label v-if="index == 1">
                                                <label v-if="item.data[0].room_type == 2">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                                <label v-if="item.data[1] && item.data[1].room_type == 2">{{item.data[1].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[1].price}}</i>）</label>
                                            </label>
                                            <label v-if="index == 2">
                                                <label v-if="item.data[0].room_type == 3">{{item.data[0].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[0].price}}</i>）</label>
                                                <label v-if="item.data[1] && item.data[1].room_type == 3">{{item.data[1].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[1].price}}</i>）</label>
                                                <label v-if="item.data[2] && item.data[2].room_type == 3">{{item.data[2].num}}间&nbsp;&nbsp;（<i class="text-warning">&yen;{{item.data[2].price}}</i>）</label>
                                            </label>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                    <el-button class="mt-5" v-if="Detail.info.hotel_info.status == 0" type="primary" @click="cancel">取消</el-button>
                </div>
                <div v-else>
                    <el-row>
                        <el-col :span="12" class="text-left colline">
                            <div>酒店名称：{{Detail.store_title}}</div>
                            <div>活跃等级：<img class="mr-3 pt-small" :src="Detail.gradePic ? '/images/grade/'+ Detail.gradePic : ''" /></div>
                            <div>酒店星级：<span class="text-warning">{{Detail.star | formatVar('HotelStar')}}</span></div>
                        </el-col>
                        <el-col :span="12" class="text-left">
                            <div class="d-flex flex-wrap">
                            <left-text :width="120" leftText="区域"/><span>{{Detail.proName}}/{{Detail.cityName}}/{{Detail.disName}}</span>
                            </div>
                            <div class="d-flex flex-wrap mt-2 mb-2">
                            <left-text :width="120" leftText="提交时间"/><span class="mt-1">{{Detail.time | formatTimestamp(1)}}</span> 
                            </div>
                            <div class="d-flex flex-wrap" v-if="userLoginMessage.type != 2">
                                <left-text :width="120" leftText="提交人/职位/手机号"/><span>{{Detail.user_name}}&nbsp;&nbsp;/&nbsp;&nbsp;{{Detail.position}}&nbsp;&nbsp;/&nbsp;&nbsp;{{Detail.user_mobile}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="text-left mt-2">房态信息：<el-button v-if="Detail.travel_push_time > 0 && Detail.hotel_push_time > 0" size="small" class="ml-1" @click="showroom = !showroom">{{showroom ? '收起房态信息' : '展开房态信息'}}</el-button></div>
                    <div v-show="showroom" class="specialDis">
                        <el-input :disabled="!queryCon.edit" class="mt-3" v-if="Detail.room_state_type == '2'" :rows="4" type="textarea" v-model="Detail.data.remarks" />
                        <div v-else>
                            <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
                            <ul class="border-left border-right">
                                <li v-for="(item, index) in Detail.data" :key="index" class="roomlist">
                                    <label :class="{'text-danger': index.charAt(7) == '五' || index.charAt(7) == '六', 'height1': item.length == 1, 'height2': item.length == 2}">{{index}}</label>
                                    <label>
                                        <div v-for="(v,ind) in item" :key="ind">
                                            <span>{{v.typeName}}</span>
                                            <span><el-input v-model="v.num" maxlength="4" :disabled="!queryCon.edit" size="small" /></span>
                                            <span class="text-warning">&yen;&nbsp;<el-input v-model="v.price" class="pl-0" maxlength="7" :disabled="!queryCon.edit" size="small" /></span>
                                        </div>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <el-button class="mt-5" type="primary" v-if="queryCon.edit" @click="adminSave">保存</el-button>
                    <div v-else><el-button class="mt-5" type="primary" @click="mate" v-if="(Detail.travel_push_time == 0 || Detail.hotel_push_time == 0) && userLoginMessage.type != 2">开始匹配</el-button></div>
                </div>
            </div>
            <div v-if="(Detail.travel_push_time > 0 || Detail.hotel_push_time > 0) && userLoginMessage.type != 2" :class="{'load-area': AdminDataLists.lists.length > 0,'pb-4': true}">
                <header class="pl-3">推送信息</header>
                <div class="ml-3 mr-3">
                <el-tabs class="mt-3 mb-3 childtab" type="card" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="采购商推送" :disabled="Detail.travel_push_time == 0" name="2" />
                    <el-tab-pane label="酒店推送" :disabled="Detail.hotel_push_time == 0" name="3" />
                </el-tabs>
                <div class="text-left mb-2" v-if="activeName == '2'">
                    <label>共匹配采购商用户：<span class="text-blue">{{Detail.travel_succ_nums + Detail.travel_fail_nums}}</span>&nbsp;人</label>
                    <label>
                        通知成功<span class="text-success"> {{Detail.travel_succ_nums}} </span>人
                        通知失败<span class="text-danger"> {{Detail.travel_fail_nums}} </span>人
                    </label>
                </div>
                <div class="text-left mb-2" v-else>
                    <label>共匹配酒店用户：<span class="text-blue">{{Detail.hotel_succ_nums + Detail.hotel_fail_nums}}</span>&nbsp;人</label>
                    <label>
                        通知成功<span class="text-success"> {{Detail.hotel_succ_nums}} </span>人
                        通知失败<span class="text-danger"> {{Detail.hotel_fail_nums}} </span>人
                    </label>
                </div>
                <el-table
                    ref="multipleTable"
                    :data="AdminDataLists.lists"
                    v-if="AdminDataLists.lists.length > 0"
                    tooltip-effect="dark"
                    style="width: 100%">
                    <el-table-column type="index" width="50" label="序号" />
                    <el-table-column :label="activeName == 2 ? '采购商名称' : '酒店名称'">
                        <template slot-scope="scope"><div class="text-blue">{{scope.row.title}}</div></template>
                    </el-table-column>
                    <el-table-column v-if="activeName == 3"  label="星级" width="120">
                        <template slot-scope="scope">
                            {{scope.row.star | formatVar('HotelStar')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="省市区">
                        <template slot-scope="scope">
                            {{scope.row.provinceName}} / {{scope.row.cityName}} / {{scope.row.districtName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="认证" width="100">
                        <template slot-scope="scope">
                            <div :class="[scope.row.verify==1?'text-success':'text-danger']">{{scope.row.verify | formatVar('verifyType')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="签约类型" v-if="activeName == 3" width="100">
                        <template slot-scope="scope">
                            <div :class="[scope.row.contract > 0 ?'text-success':'text-danger']">{{scope.row.contract > 0 ? '已签约' : '未签约'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="通知状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.room_state_push_arr">
                                <div v-if="scope.row.room_state_push_arr.length < 2" class="d-flex flex-column">
                                    <span><i class="iconfont icon-weixin1 mr-1" :class="[scope.row.room_state_push_arr[0].push_code == 1 ? 'text-success' : 'text-muted']"></i>{{scope.row.room_state_push_arr[0].truename}}/
                                    <span class="text-muted">{{scope.row.room_state_push_arr[0].position_name}}/{{scope.row.room_state_push_arr[0].mobile}}</span></span>
                                    <span v-if="scope.row.room_state_push_arr[0].push_code == 1" class="text-success">通知成功</span>
                                    <span v-else class="text-danger">通知失败（{{scope.row.room_state_push_arr[0].push_code | formatVar('wechatCode')}}）</span>
                                </div>
                                <el-popover v-else placement="right" trigger="hover">
                                    <div v-for="(item, index) in scope.row.room_state_push_arr" :key="index">
                                        <i class="iconfont icon-weixin1 mr-1" :class="[item.push_code == 1 ? 'text-success' : 'text-muted']"></i>
                                        <span class="ml-2">{{item.truename}}/</span>
                                        <span class="text-muted mr-2">{{item.position_name}}/{{item.mobile}}</span>
                                        <span v-if="item.push_code == 1" class="text-success">通知成功</span>
                                        <span v-else class="text-danger">通知失败（{{item.push_code | formatVar('wechatCode')}}）</span>
                                    </div>
                                    <label slot="reference">已通知&nbsp;<span class="text-blue">{{scope.row.room_state_push_arr.length}}</span>人</label>
                                </el-popover>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
                <el-pagination background layout="prev, pager, next" class="mt-4"
                        v-if="AdminDataLists.lists.length > 0"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapState, mapMutations } from 'vuex'
export default {
    name: 'RoomDetail',
    data () {
        return {
            titleArr:['时间','房型','余房','团队价'],
            typeArr: ['日期', '大床房', '标准间', '三人间'],
            Detail: {},
            path: '',
            activeName: '2',
            showroom: true,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear() + '-',
            year1: new Date().getFullYear() + 1 + '-',
            isClick: true
        }
    },
    computed: {
        ...mapState(['AdminDataLists', 'userLoginMessage']),
        queryCon() { return this.$route.query }
    },
    watch:{
        queryCon() { this.getLists() },
    },
    created () {
        this.path = sessionStorage.getItem('path')
        this.getDetail()
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['getAdminDataLists']),
        //判断时间是星期几
        getMyDay(date){
            date = new Date(date)
            let week;
            if(date.getDay()==0) week="周日"
            if(date.getDay()==1) week="周一"
            if(date.getDay()==2) week="周二"
            if(date.getDay()==3) week="周三"
            if(date.getDay()==4) week="周四"
            if(date.getDay()==5) week="周五"
            if(date.getDay()==6) week="周六"
            return week;
        },
        //根据路径来源判断详情显示
        async getDetail () {
            let data = [this.queryCon.store_id, this.queryCon.type, this.queryCon.room_state_id]
            let resData,url,params
            if (this.path == 'hotel' && this.userLoginMessage.type == 3) {
                url = 'pc/Hotel/getRoomStateDetails'
                params = {store_id:data[0], store_type:data[1], room_state_id:data[2]}
            }else {
                url = 'pc/Common/examineRoomDetail'
                params = {store_id:data[0], id:data[2]}
            }
            resData = await this.$axios.post(url, params)
            if (resData.code === '00000') {
                this.Detail = resData
                if (this.Detail.travel_push_time == 0) this.activeName = '3'
                if (this.userLoginMessage.type == 3) {
                    this.$nextTick(_ => {
                        let uls = document.querySelectorAll('.ullinetype label')
                        for (let i=0;i<uls.length;i++) { if(uls[i].innerText == '') uls[i].innerText = '-' }
                    })
                }
                //let current = Math.round((new Date().getTime() - 24*60*60*1000) / 1000)
                if (url == 'pc/Common/examineRoomDetail' && (resData.hotel_push_time > 0)) this.getLists(resData.hotel_push_time)
                if (url == 'pc/Common/examineRoomDetail' && (resData.travel_push_time > 0)) this.getLists(resData.travel_push_time)
                else this.isClick = false
            }
        },
        // 开始匹配
        mate () {
            let name = ''
            if (this.Detail.hotel_push_time == 0 && this.Detail.travel_push_time == 0) name = ''
            else if (this.Detail.hotel_push_time == 0) name = 'hotel'
            else name = 'travel'
            this.$router.push({name:'MatchList', query:{id: this.queryCon.room_state_id, page: 1, name: name}})
        },
        cancel () {
            this._confirm('确认取消么？',() => { this.confirmCancel() });
        },
        async confirmCancel () {
            let resData = await this.$axios.post('pc/Hotel/cancelRoomState', {
                store_id: this.queryCon.store_id,
                store_type: this.queryCon.type,
                store_title: this.queryCon.store_title,
                room_state_id: this.queryCon.room_state_id
            })
            if (resData.code === '00000') {
                this.$message.success('已取消')
                this.getDetail()
            }
        },
        getLists (room_state_push_time) {
            this.UPDATECURRENTSTORE({type:Number(this.activeName)});
            let data = {
                storeType:Number(this.activeName),
                room_state_push_time
            }
            this.getAdminDataLists({
                type:'storeList',
                data
            })
        },
        // 切换推送信息
        handleClick () {
            if (this.isClick) {
                this.$router.push({name,query:{...this.queryCon,page:1}})
                if (this.activeName == '2') this.getLists(this.Detail.travel_push_time)
                else this.getLists(this.Detail.hotel_push_time)
            }
        },
        // 管理员编辑房态
        async adminSave () {
            let data = {
                store_title: this.Detail.store_title,
                store_id: this.queryCon.store_id,
                store_type: this.queryCon.type,
                room_state_id: this.queryCon.room_state_id,
            }
            if (this.Detail.room_state_type == '1') {
                let times = [],
                    roomObj = [],
                    arr = [];
                for (let key in this.Detail.data) { times.push(key.substring(0,5)); arr.push(this.Detail.data[key])}
                for (let key in arr) {
                    for (let m in arr[key]) {
                        roomObj.push(arr[key][m])
                    }
                }
                let room_arr = roomObj.map((v, index) => {
                    return {
                        date: v.date.substring(0,5),
                        room_type: v.room_type,
                        price: Number(v.price),
                        num: Number(v.num),
                    }
                })
                let regFull =  /^([1-9]{1}|[1-9]{1}\d{1,3})$/;
                let price = /^[1-9]\d{1,4}(\.\d{1,2})?$/;
                for (let i=0; i < room_arr.length; i++) {
                    if(!regFull.test(room_arr[i].num)) {this.$message.error('请检查' + room_arr[i].date + '余房数量是否为1~10000之间的正整数'); return}
                    if(!price.test(room_arr[i].price)) {this.$message.error('请检查' + room_arr[i].date + '团队价格是否为10~100000之间的正整数或小数'); return}
                }
                data.date = times.join(',')
                data.room_arr = room_arr
            } else {
                data.remarks = this.Detail.data.remarks
            }
            let res = await this.$axios.post('/pc/Admin/editRoomState',data);
            if (res.code === '00000') {
                this._alert('保存成功', () => this.$router.push({name: 'StoreManage',query:{storeType:3,page:1,back: 'back',active: this.queryCon.activeName}}))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
header{
    height: 40px;
    line-height: 40px;
    text-align: left;
    background-color: #f8f8f8
}
.load-area{
    padding: 0
}
.box-shadow{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.colline{
    div{
        height: 25px;
        line-height: 25px
    }
}
.list-head{
    border: 1px solid #dee2e6;
    color: #919191;
}
.height1{
    height: 45px!important;
    line-height: 45px!important
}
.height2{
    height: 90px!important;
    line-height: 90px!important
}
.roomlist{
    label{
        display: inline-block;
        vertical-align: middle
    }
    label:first-child{
        width: 25%;
        height: 135px;
        line-height: 135px;
        border-bottom: 1px solid #e5e5e5
    }
    label:last-child{
        width: 75%
    }
    span{
        width: 33%;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        border-left: 1px solid #e5e5e5;
        box-sizing: border-box;
        vertical-align: top;
        border-bottom: 1px solid #e5e5e5;
        .el-input{
            width: 50%
        }
    }
}
.linetype{
    span{
        width: 25%;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        border-right: 1px solid #e5e5e5;
        box-sizing: border-box;
        border-bottom: 1px solid #e5e5e5;
        vertical-align: middle;
        &:first-child{
            border-left: 1px solid #e5e5e5;
            text-align: left;
            padding-left: 11%
        }
    }
    .el-input{
        width: 35%
    }
}
.Rstatus{
    float: right;
    margin-right: 15px
}
.childtab{
    width: 209px
}
</style>
